export class StartLoadTestMode {
   public static readonly type = '[Brick Wall Actions] Start load test mode';
}

export class StopLoadTestMode {
   public static readonly type = '[Brick Wall Actions] Stop load test mode';
}
